import { getInfo } from "./api";
import { useQuery } from "@tanstack/react-query";
import { reactQueryCacheAndRefetchOptions } from "@";

// Query keys for React Query
export const projectsKeys = {
  info: ["info"],
};

// Query hook for fetching info data
export const useInfoQuery = () => {
  return useQuery({
    queryKey: projectsKeys.info,
    queryFn: async () => {
      const { data } = await getInfo();
      return data;
    },
    ...reactQueryCacheAndRefetchOptions,
  });
};
